import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  html, body, #root {
    height: 100%;
  }

  html {
    color-scheme: ${({ theme }) => theme.mode};
  }

  body {
    margin: 0;
    font-family: ${({ theme }) => theme.font.primary};
    font-size: 15px;
    line-height: 1.5;
    color: ${({ theme }) => theme.colors.textPrimary};
    background: ${({ theme }) => theme.colors.bgPage};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    transition: background-color ${({ theme }) => theme.transitions.base},
      color ${({ theme }) => theme.transitions.base};
  }

  button, input, textarea, select {
    font-family: inherit;
    font-size: inherit;
    color: inherit;
  }

  button {
    cursor: pointer;
    border: none;
    background: transparent;
    color: inherit;
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
  }

  :focus-visible {
    outline: 3px solid ${({ theme }) => theme.colors.borderFocus};
    outline-offset: 2px;
    border-radius: 6px;
  }

  ::selection {
    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primaryOn};
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-text-fill-color: ${({ theme }) => theme.colors.textPrimary};
    -webkit-box-shadow: 0 0 0 1000px ${({ theme }) => theme.colors.bgSurface} inset;
    transition: background-color 9999s ease-in-out 0s;
  }
`;
